import { render, staticRenderFns } from "./ScoreChangeRecord.vue?vue&type=template&id=785ade87&"
import script from "./ScoreChangeRecord.vue?vue&type=script&lang=js&"
export * from "./ScoreChangeRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports